import { getAzureErrors, getAzureErrorsAsString, SentryReporterService } from '@mews/framework';
import { RequestError } from '@mews/framework/data-access';

const ignoredWarningMessages = [
    "103: Field 'time' on type 'Envelope' is older than the allowed min date",
    "104: Field 'time' on type 'Envelope' is newer than the allowed max date",
    /*
     * We tried finding a fix for this issue but we weren't able to do so in 1 year, as you can see here https://mews.myjetbrains.com/youtrack/issue/kanban-3647, https://mews.slack.com/archives/C01RVEGPTB5/p1680178945063669
     * It seems harmless and nobody reported any issues that would be related to it.
     * It shouldn't prevent users from using the app.
     */
    'Component private link id does not match incoming link id and private endpoint connection does not have restrictive flag disabled',
];

const isIgnoredWarningMessage = (errorMessage?: unknown) =>
    errorMessage != null &&
    typeof errorMessage === 'string' &&
    ignoredWarningMessages.some((message) => errorMessage.includes(message));

const shouldReportAzureError = (error: RequestError | Error) => {
    const azureErrors = getAzureErrors(error);

    if (!Array.isArray(azureErrors) || azureErrors.length <= 0) {
        return true;
    }

    const filteredErrors = azureErrors.filter(
        (azureError?: { message?: unknown }) => !isIgnoredWarningMessage(azureError?.message)
    );

    return filteredErrors.length > 0;
};

export const handleAzureAppInsightsError = (sentryReporterService?: SentryReporterService) => (error: Error) => {
    if (sentryReporterService != null && shouldReportAzureError(error)) {
        sentryReporterService.logWarning({
            error,
            extra: {
                origin: 'AzureAppInsightsLoggerAdapter',
                errors: getAzureErrorsAsString(error),
            },
        });
    }
};
